<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fff;height:100%">
        <v-card elevation="0">
            <v-card-title>
            Pedidos
            <div class="flex-grow-1"></div>
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar Pedidos"
                single-line
                hide-details
            ></v-text-field>
            </v-card-title>
            <v-data-table
            :footer-props="{itemsPerPageOptions:[50,100,200]}"
            :headers="headers"
            :items="orders"
            :search="search"
            >
         
          
            </v-data-table>
        </v-card>
    </v-sheet>
</template>

<script>
import OrdersService from "../../../app/rest/orders"

var ordersService = null;

export default {
    components:{ },
    data: () => ({
        search: '',
        orders:[],
        headers: [
          {
            text: 'Pedido',
            align: 'left',
            sortable: false,
            value: 'id',
          },
          { text: 'Nome do produto', value: 'product_name' },  
          { text: 'Tipo do produto', value: 'product.flavor' },
          { text: 'Formato produto', value: 'product.type.slug' },   
          { text: 'Status', value: 'status' },      
          { text: 'Parcelas', value: 'installment' }, 
          { text: 'Total', value: 'total' },         
          { text: 'Total Pago', value: 'total_payed' },
          { text: 'Data de criação', value: 'created_at' },
        ],
    }),
    beforeCreate:function(){
         this.$store.dispatch('loading')
        ordersService = OrdersService.build();
        ordersService.get_all().then( e =>{
            if(e.status=="ok"){
                this.orders = e.items.orders;
            }

        }).catch( e =>{
            console.log(e);
        }).finally( () =>{
             this.$store.dispatch('loading', false)
        });
    },
    methods:{
       
    }
};
</script>